import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { useState } from 'react';
import { Message as Message$2, MessageTop, MessageTopContent, Header, HeaderContent, MessageBody } from './style.js';
import texts from './Message.texts.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import useGlobals from '../../hooks/useGlobals.js';
import Icon from '../Icon/Icon.js';
import { UI_INFO } from '../../icons/UI_INFO.js';
import { UI_WARNING } from '../../icons/UI_WARNING.js';
import { UI_CHECKMARK_CIRLCE } from '../../icons/UI_CHECKMARK_CIRCLE.js';
import Link from '../Link/Link.js';
import { UI_CHEVRON_UP } from '../../icons/UI_CHEVRON_UP.js';
import { UI_CHEVRON_DOWN } from '../../icons/UI_CHEVRON_DOWN.js';

var _excluded = ["className", "header", "children", "expandable", "initiallyExpanded", "link", "linkText", "messageType"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var messageTypeIcons = {
  info: UI_INFO,
  error: UI_WARNING,
  alert: UI_INFO,
  success: UI_CHECKMARK_CIRLCE
};
var Message = function Message(_ref) {
  var className = _ref.className,
    header = _ref.header,
    children = _ref.children,
    expandable = _ref.expandable,
    initiallyExpanded = _ref.initiallyExpanded,
    link = _ref.link,
    linkText = _ref.linkText,
    messageType = _ref.messageType,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useGlobals = useGlobals(),
    culture = _useGlobals.culture;
  var _useState = useState(expandable && initiallyExpanded),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  if (typeof header !== 'string' || !header) {
    return undefined;
  }
  var PotentialMessageBody = children && /*#__PURE__*/jsxs(MessageBody, {
    $messageType: messageType,
    $expanded: expanded,
    children: [children, link && linkText && /*#__PURE__*/jsx(Link, {
      href: link,
      target: "_blank",
      rel: "noopener noreferrer",
      className: "message__link",
      children: linkText
    })]
  });
  var expandIconPath = expanded ? UI_CHEVRON_UP : UI_CHEVRON_DOWN;
  var expandableWithChildren = children && expandable;
  var messageTopProps = expandableWithChildren ? {
    as: 'button',
    type: 'button',
    'aria-label': texts[culture].expandableWithChildren,
    'aria-expanded': expanded,
    onClick: function onClick() {
      return setExpanded(!expanded);
    }
  } : {
    as: 'div'
  };
  return /*#__PURE__*/jsxs(Message$2, _objectSpread(_objectSpread({
    className: className,
    $messageType: messageType
  }, rest), {}, {
    children: [/*#__PURE__*/jsxs(MessageTop, _objectSpread(_objectSpread({}, messageTopProps), {}, {
      $expanded: expanded,
      $expandable: expandableWithChildren,
      $messageType: messageType,
      children: [/*#__PURE__*/jsx(Icon, {
        path: messageTypeIcons[messageType],
        "aria-hidden": "true",
        className: "sg-message-type-icon"
      }), /*#__PURE__*/jsxs(MessageTopContent, {
        children: [/*#__PURE__*/jsxs(Header, {
          $messageType: messageType,
          $expandable: expandableWithChildren,
          children: [/*#__PURE__*/jsx(HeaderContent, {
            $withSubtext: children,
            $expandable: expandableWithChildren,
            children: header
          }), expandableWithChildren && /*#__PURE__*/jsx(Icon, {
            "aria-hidden": "true",
            path: expandIconPath,
            size: "xs"
          })]
        }), !expandable && PotentialMessageBody]
      })]
    })), expanded && PotentialMessageBody]
  }));
};
Message.defaultProps = {
  className: null,
  children: null,
  initiallyExpanded: false,
  expandable: false,
  link: null,
  linkText: null,
  messageType: 'info'
};
var Message$1 = Message;

export { Message$1 as default };
//# sourceMappingURL=Message.js.map
